module.exports = __webpack_public_path__ + "static/media/img1-400-400.86ecb240.webp";